import { formatPlanStartTime } from '@peles/shared';
import type { ClientFloorPlan } from '../../api/portal';

/** The part of the evening a plan lays out and when it begins — "Dinner · 7:30 PM". */
export function ClientPlanPart({
  plan,
}: {
  plan: Pick<ClientFloorPlan, 'id' | 'eveningPart' | 'startTime'>;
}) {
  const text = [plan.eveningPart?.label, formatPlanStartTime(plan.startTime)]
    .filter(Boolean)
    .join(' · ');
  return text ? (
    <p className="text-sm text-primary-700" data-testid={`client-plan-part-${plan.id}`}>
      {text}
    </p>
  ) : null;
}
